import { CircularProgress, Stack } from "@mui/material";

export const Loading = () => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: "100vh",
      }}
    >
      <CircularProgress />
    </Stack>
  );
};
